// app/frontend/pages/Artists/PortalPasswordPrompt.tsx
import React from 'react';
import { Head, useForm } from '@inertiajs/react';
import { Container, Title, Text, Button, Stack, PasswordInput, Paper, Image } from '@mantine/core';
import Layout from '../../components/Layout';
import { notifications, Notifications } from '@mantine/notifications';

interface PortalPasswordPromptProps {
  artist?: any;
}

type NextPageWithLayout = React.FC<PortalPasswordPromptProps> & {
  layout?: (page: React.ReactNode) => React.ReactNode;
};

const PortalPasswordPrompt: NextPageWithLayout = ({ artist }) => {
  console.log('PortalPasswordPrompt props:', { artist });

  const { data, setData, post, processing, errors } = useForm({
    password: '',
  });

  if (!artist) {
    return (
      <Container size="sm" py="xl">
        <Text className="text-white" ta="center">
          Loading artist portal...
        </Text>
      </Container>
    );
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted with password:', data.password);

    post(`/artists/${artist.slug}/authenticate_portal`, {
      onSuccess: () => {
        console.log('Success!');
        notifications.show({
          title: 'Success!',
          message: 'Portal access granted!',
          color: 'green',
        });
      },
      onError: (errors) => {
        console.log('Error:', errors);
        notifications.show({
          title: 'Authentication Failed',
          message: 'Invalid password. Please try again.',
          color: 'red',
        });
      },
    });
  };

  return (
    <>
      <Head>
        <title>Portal Access | Where Can We Dance</title>
      </Head>

      <Container size="sm" py="xl" style={{ textAlign: 'center', minHeight: '100vh' }}>
        <Paper
          p="xl"
          radius="lg"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Notifications position="top-right" />

          <Image
            src={artist.avatar || 'https://dancewise.s3.amazonaws.com/misc-images/Blank+Avatar.png'}
            alt={`${artist.name} avatar`}
            w={200}
            h={200}
            radius="50%"
            className="mb-4"
            style={{ objectFit: 'cover', margin: '0 auto' }}
          />

          <Stack gap="lg" align="center">
            <Title order={2} ta="center" className="text-white rubik-header">
              Booking Portal for {artist.name}
            </Title>

            <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '400px' }}>
              <Stack gap="md">
                <PasswordInput
                  label="Portal Password"
                  placeholder="Enter portal password"
                  value={data.password}
                  onChange={(e) => setData('password', e.target.value)}
                  required
                  autoFocus
                  error={errors.password}
                  styles={{
                    label: { color: '#f2f2f2', fontWeight: 500 },
                    input: {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      color: '#f2f2f2',
                    },
                  }}
                />

                <Button type="submit" loading={processing} color="#EA580C" size="md" fw={500} fullWidth>
                  Enter Booking Portal
                </Button>
              </Stack>
            </form>
          </Stack>
        </Paper>
      </Container>
    </>
  );
};

PortalPasswordPrompt.layout = (page: React.ReactNode) => <Layout>{page}</Layout>;

export default PortalPasswordPrompt;
